
import VueResizable from 'vue-resizable';
import Component from 'vue-class-component';
import Draggable from 'vuedraggable';
import Vue from 'vue';
import { ResizingZone } from '@/wms/domain/layout/configResizing/ResizingZone';
import LayoutZone from '@/wms/infrastructure/ui/Layout/zone/LayoutZone.vue';
import LayoutRack from '@/wms/infrastructure/ui/Layout/rack/LayoutRack.vue';
import AddStore from '@/wms/infrastructure/ui/Layout/store/AddStore.vue';
import { Prop } from 'vue-property-decorator';
import { Warehouse } from '@/settings/domain/warehouse/Warehouse';
import { Store } from '@/wms/domain/layout/store/Store';
import { Inject } from '@/core/di/Inject';
import { TYPES } from '@/core/config/Types';
import { CreateStore } from '@/wms/application/layout/store/create/CreateStore';
import { FindAllStorebyWarehouse } from '@/wms/application/layout/store/search/FindAllStorebyWarehouse';
import { ZoneL } from '@/wms/domain/layout/zone/ZoneL';
import { FindAllRacks } from '@/wms/application/layout/rack/search/FindAllRacks';
import { FindAllZone } from '@/wms/application/layout/zone/search/FindAllZone';
import { FindCommodityTypeByStatus } from '@/freight/application/commodity_type/search/FindCommodityTypesByStatus';
import { CreateLayoutConfig } from '@/wms/application/layout/config/create/CreateLayoutConfig';
import { FindLayoutConfigByWarehouseAndStore } from '@/wms/application/layout/config/search/FindLayoutConfigByWarehouseAndStore';
import { ValidationObserver } from 'vee-validate';
import { DeleteZoneLayoutConfig } from '@/wms/application/layout/config/delete/DeleteZoneLayoutConfig';
import { DeleteRackLayoutConfig } from '@/wms/application/layout/rack/delete/DeleteRackLayoutConfig';
import Swal from 'sweetalert2';
import { FileFindAll } from '@/settings/application/uses_cases/file/search/FileFindAll';

@Component({
  name: 'LayoutStore',
  components: { VueResizable, Draggable, LayoutZone, LayoutRack, AddStore },
  filters: {
    checkEmpty(value: any) {
      return typeof value !== 'number' ? 0 : value;
    }
  }
})
export default class LayoutStore extends Vue {
  @Inject(TYPES.CREATE_STORE)
  readonly createStore!: CreateStore;
  @Inject(TYPES.FIND_ALL_STORE_WAREHOUSE)
  readonly FindAllStorebyWarehouse!: FindAllStorebyWarehouse;
  @Inject(TYPES.FINDALL_LAYOUT_ZONE)
  readonly findAllZone!: FindAllZone;
  @Inject(TYPES.FIND_ALL_RACKS)
  readonly findAllRacks!: FindAllRacks;
  @Inject(TYPES.COMMODITY_TYPE_FIND_BY_STATUS)
  readonly findCommodityByStatus!: FindCommodityTypeByStatus;
  @Inject(TYPES.LAYOUT_CONFIG_SAVE)
  readonly createLayoutConfig!: CreateLayoutConfig;
  @Inject(TYPES.LAYOUT_CONFIG_FIND)
  readonly FindLayoutConfig!: FindLayoutConfigByWarehouseAndStore;
  @Inject(TYPES.LAYOUT_CONFIG_DELETE_ZONE)
  readonly deleteZoneFromdb!: DeleteZoneLayoutConfig;
  @Inject(TYPES.LAYOUT_CONFIG_DELETE_RACK)
  readonly deleteRackFromdb!: DeleteRackLayoutConfig;
  @Inject(TYPES.FINDALL_FILE)
  readonly fileFindAll!: FileFindAll;

  handlers = ['r', 'rb', 'b', 'lb', 'l', 'lt', 't', 'rt'];
  resizingZone: any[] = [];
  event = '';
  store: Store | null = null;
  storeWarehouse: Store[] = [];
  storeLayout = '';
  confirmStep1 = false;
  zoneSelect: any = null;
  zoneList: ZoneL[] = [];
  myArrayRack: any[] = [];
  commodityList = [] as any;
  isLoading = false;

  $refs!: {
    LayoutRackMdl: HTMLFormElement;
    LayoutZoneMdl: HTMLFormElement;
    ConfigRacksMdl: HTMLFormElement;
    layoutStore: HTMLFormElement;
    rackForm: InstanceType<typeof ValidationObserver>;
  };

  @Prop({ type: Object, required: true }) readonly warehouse!: Warehouse;

  created() {
    this.findAllbyWarehouse(this.warehouse.code);
    this.findRacks();
    this.findZone();
    this.getAllCommodityActive();
  }

  get handlersComputed() {
    if (this.confirmStep1) return [];

    return this.handlers;
  }

  get filteredZoneList() {
    return this.zoneList.filter((item: any) => {
      return this.searchInZones(item.zoneId) ? false : true;
    });
  }

  set filteredZoneList(newValue: any) {
    this.zoneList = newValue;
  }

  get filteredRacks() {
    return this.myArrayRack.filter(item => {
      return this.searchInRacks(item.id) ? false : true;
    });
  }

  set filteredRacks(newValue: any) {
    this.filteredRacks = newValue;
  }

  getValidationState({ dirty, validated, valid = null }: { dirty: any; validated: any; valid: any }) {
    return dirty || validated ? valid : null;
  }

  customPlaceholderStore(store: Store) {
    return `${store.storeId} - ${store.storeName}`;
  }

  async deleteZone(index: any, element: any) {
    const confirm = await this.confirmAlert();
    if (!confirm.isConfirmed) return;
    this.isLoading = true;
    if ('id' in element && element.id != 0) {
      await this.deleteZoneFromdb.execute(element).then(() => {
        this.isLoading = false;
        this.findLayoutConfig(this.store);
      });
    }
    const idx = this.resizingZone.indexOf(element);
    if (idx > -1) {
      this.resizingZone.splice(idx, 1);
    }
    this.isLoading = false;
  }
  async deleteRack(index: any, element: any) {
    const confirm = await this.confirmAlert();
    if (!confirm.isConfirmed) return;
    this.isLoading = true;
    if (element.zoneId) {
      await this.deleteRackFromdb.execute(element).then(() => {
        this.isLoading = false;
        this.findLayoutConfig(this.store);
      });
    }
    const idx = this.zoneSelect.rack.indexOf(element);
    if (idx > -1) {
      this.zoneSelect.rack.splice(idx, 1);
    }
    this.isLoading = false;
  }

  //Verificar esta funcion para revisar que todos los datos en los racks se hayan completado
  checkRacks() {
    const lastRack = this.zoneSelect;
    let isOk = false;
    this.resizingZone.map(async item => {
      this.zoneSelect = await item;
      isOk = await this.$refs.rackForm.validate();
    });
    this.zoneSelect = lastRack;
    return isOk;
  }

  openRacksModal() {
    if (this.confirmStep1) this.$refs.ConfigRacksMdl.show();
  }

  async confirmLayout(step: number) {
    if (step === 1) {
      this.confirmStep1 = true;
    }

    if (this.zoneSelect && this.confirmStep1 && !(await this.$refs.rackForm.validate())) {
      this.$swal(`${this.$t('general.warning')}`, `${this.$t('general.fillAllFields')}`, 'warning');
      return;
    }

    this.isLoading = true;
    this.checkLayoutProperties();
    this.createLayoutConfig
      .execute(this.resizingZone)
      .then((response: any) => {
        this.isLoading = false;
        this.findLayoutConfig(this.store);
        return response;
      })
      .catch((err: any) => {
        throw new Error(`${err}`);
      });
  }
  cancelLayout(step: number) {
    if (step === 1) {
      this.confirmStep1 = false;
    }
  }
  setSelectedZone(config: any) {
    if (this.confirmStep1) {
      this.zoneSelect = config;
    }
  }
  async findLayoutConfig(optionSelected: any) {
    this.zoneSelect = null;
    this.confirmStep1 = false;
    this.isLoading = true;

    await this.fileFindAll
      .execute(optionSelected.imgStore)
      .then((res: any) => {
        this.storeLayout = res.base64;
        this.isLoading = false;
      })
      .catch((err: any) => {
        this.isLoading = false;
        throw new Error(`${err}`);
      });

    const pyload = {
      state: true,
      warehouseCode: this.warehouse.code,
      storeId: optionSelected.storeId
    };

    await this.FindLayoutConfig.execute(pyload)
      .then((response: any) => {
        this.isLoading = false;
        this.resizingZone = response;
        if (this.resizingZone.length > 0) {
          this.confirmStep1 = true;
          this.zoneSelect = this.resizingZone[0];
        }
      })
      .catch((err: any) => {
        this.isLoading = false;
        throw new Error(`${err}`);
      });
  }

  findRacks() {
    this.findAllRacks
      .execute()
      .then((resp: any) => {
        this.myArrayRack = resp;
      })
      .catch((err: any) => {
        throw new Error(`${err}`);
      });
  }
  controllerModal() {
    this.$refs['LayoutRackMdl'].hide();
    this.findRacks();
  }
  controllerModalZone() {
    this.$refs['LayoutZoneMdl'].hide();
    this.findZone();
  }
  controllerModalStore() {
    if (this.store) this.store = null;
    this.$refs.layoutStore.hide();
    this.findAllbyWarehouse(this.warehouse.code);
  }
  addTagStore(newTag: string) {
    if (newTag.length > 20) {
      this.$swal(
        `${this.$t('general.warning')}`,
        `${this.$t('general.charlenght')}`.replace('$', `${this.$t('general.store')}`.toLowerCase()).replace('%', '20'),
        'warning'
      );
      return;
    }
    const store: Store = new Store();
    store.storeId = 0;
    store.storeName = newTag;
    store.active = true;
    store.warehouse = this.warehouse;
    this.createStore.execute(store).then(() => {
      this.findAllbyWarehouse(this.warehouse.code);
    });
  }
  findAllbyWarehouse(code: any) {
    this.FindAllStorebyWarehouse.execute(code)
      .then((resp: any) => {
        this.storeWarehouse = Array.isArray(resp) ? resp : [];
      })
      .catch((err: any) => {
        throw new Error(`${err}`);
      });

    return null;
  }
  findZone() {
    this.findAllZone
      .execute()
      .then((resp: any) => {
        this.zoneList = resp || ([] as ZoneL[]);
      })
      .catch((err: any) => {
        throw new Error(`${err}`);
      });
  }
  getAllCommodityActive() {
    this.findCommodityByStatus
      .execute(true)
      .then((response: any) => {
        this.commodityList = response;
      })
      .catch(err => {
        this.commodityList = [];
        throw new Error(`${err}`);
      });
  }
  detectMove(evt: any) {
    const item = String(evt.item.attributes[1].nodeValue); //get key value zone on D&D

    if (item && this.resizingZone.length > 0) {
      // new array for map and update default config
      const newArray = this.resizingZone.map((zone: any) => {
        if (zone.zoneId == item) {
          //object Config for initial ResizingZone
          const obj = new ResizingZone();
          // set key and name zone for config obj
          obj.zoneId = zone.zoneId;
          obj.zoneDescription = zone.zoneDescription;
          obj.storeId = this.store?.storeId || 0;
          obj.state = true;
          //return new object update include zone object
          return { zone, ...obj };
        }
        //return obj zone old
        return zone;
      });

      this.resizingZone = newArray.slice(); //copy aux array in config array
    }
  }
  eHandler(config: any, data: any) {
    config.width = data.width;
    config.height = data.height;
    config.left = data.left;
    config.top = data.top;
  }
  parseObj() {
    this.zoneSelect.rack = JSON.parse(JSON.stringify(this.zoneSelect.rack));
  }
  get warehouseSelected() {
    return this.warehouse.code + ' - ' + this.warehouse.description;
  }

  searchInZones(element: string) {
    let encontrado = false;
    this.resizingZone.map(item => {
      if (item.zoneId == element) {
        encontrado = true;
        return;
      }
    });
    return encontrado;
  }

  searchInRacks(element: string) {
    if (this.zoneSelect == null) return;
    let encontrado = false;
    this.zoneSelect.rack.map((item: any) => {
      if (item.id == element) {
        encontrado = true;
        return;
      }
    });
    return encontrado;
  }

  checkLayoutProperties() {
    this.resizingZone = this.resizingZone.map(item => ({
      ...item,
      left: typeof item.left == 'string' ? 0 : item.left
    }));
  }

  async confirmAlert() {
    return await Swal.fire({
      title: `${this.$t('general.confirmAction')}`,
      icon: 'info',
      text: `${this.$t('general.areyousuretodeletethis')}`,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: `${this.$t('general.delete')}`,
      cancelButtonText: `${this.$t('general.cancel')}`
    });
  }
}
